// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_svc_payment.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { grpc } from "@improbable-eng/grpc-web";
import { BrowserHeaders } from "browser-headers";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { MultiGenericPayloadResponse } from "./stcs_commons.entity";

export const protobufPackage = "stcs_cmw";

/**
 * v1.0.0
 * Request to check organization payment and subscription status
 */
export interface OrgPaymentStatusRequest {
  /** Admin or owner of the organization requesting the payment status */
  ref_id_user: string;
  /** The organization for which to check payment status */
  ref_id_org: string;
}

function createBaseOrgPaymentStatusRequest(): OrgPaymentStatusRequest {
  return { ref_id_user: "", ref_id_org: "" };
}

export const OrgPaymentStatusRequest: MessageFns<OrgPaymentStatusRequest> = {
  encode(message: OrgPaymentStatusRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_user !== "") {
      writer.uint32(10).string(message.ref_id_user);
    }
    if (message.ref_id_org !== "") {
      writer.uint32(18).string(message.ref_id_org);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OrgPaymentStatusRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOrgPaymentStatusRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_user = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OrgPaymentStatusRequest {
    return {
      ref_id_user: isSet(object.ref_id_user) ? globalThis.String(object.ref_id_user) : "",
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
    };
  },

  toJSON(message: OrgPaymentStatusRequest): unknown {
    const obj: any = {};
    if (message.ref_id_user !== "") {
      obj.ref_id_user = message.ref_id_user;
    }
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OrgPaymentStatusRequest>, I>>(base?: I): OrgPaymentStatusRequest {
    return OrgPaymentStatusRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OrgPaymentStatusRequest>, I>>(object: I): OrgPaymentStatusRequest {
    const message = createBaseOrgPaymentStatusRequest();
    message.ref_id_user = object.ref_id_user ?? "";
    message.ref_id_org = object.ref_id_org ?? "";
    return message;
  },
};

/**
 * v1.0.0
 * Service for handling organization payment operations
 */
export interface StcsWappSvcPayment {
  org_check_payment_status(
    request: DeepPartial<OrgPaymentStatusRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse>;
}

export class StcsWappSvcPaymentClientImpl implements StcsWappSvcPayment {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.org_check_payment_status = this.org_check_payment_status.bind(this);
  }

  org_check_payment_status(
    request: DeepPartial<OrgPaymentStatusRequest>,
    metadata?: grpc.Metadata,
  ): Observable<MultiGenericPayloadResponse> {
    return this.rpc.unary(
      StcsWappSvcPaymentorg_check_payment_statusDesc,
      OrgPaymentStatusRequest.fromPartial(request),
      metadata,
    );
  }
}

export const StcsWappSvcPaymentDesc = { serviceName: "stcs_cmw.StcsWappSvcPayment" };

export const StcsWappSvcPaymentorg_check_payment_statusDesc: UnaryMethodDefinitionish = {
  methodName: "org_check_payment_status",
  service: StcsWappSvcPaymentDesc,
  requestStream: false,
  responseStream: false,
  requestType: {
    serializeBinary() {
      return OrgPaymentStatusRequest.encode(this).finish();
    },
  } as any,
  responseType: {
    deserializeBinary(data: Uint8Array) {
      const value = MultiGenericPayloadResponse.decode(data);
      return {
        ...value,
        toObject() {
          return value;
        },
      };
    },
  } as any,
};

interface UnaryMethodDefinitionishR extends grpc.UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
    upStreamRetryCodes?: number[];
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
      upStreamRetryCodes?: number[];
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Observable<any> {
    const request = { ..._request, ...methodDesc.requestType };
    const maybeCombinedMetadata = metadata && this.options.metadata
      ? new BrowserHeaders({ ...this.options?.metadata.headersMap, ...metadata?.headersMap })
      : metadata ?? this.options.metadata;
    return new Observable((observer) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata ?? {},
        ...(this.options.transport !== undefined ? { transport: this.options.transport } : {}),
        debug: this.options.debug ?? false,
        onEnd: (next) => {
          if (next.status !== 0) {
            const err = new GrpcWebError(next.statusMessage, next.status, next.trailers);
            observer.error(err);
          } else {
            observer.next(next.message as any);
            observer.complete();
          }
        },
      });
    }).pipe(take(1));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export class GrpcWebError extends globalThis.Error {
  constructor(message: string, public code: grpc.Code, public metadata: grpc.Metadata) {
    super(message);
  }
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
